import React from "react";

import Banner from "../../components/Banner";
import NavBar from "../../components/Navbar";
import Section from "../../components/Section";
import DisplayList from "../../components/home/DisplayList";

function Home() {

    return (
        <>
            <NavBar />
            <Banner />

            <Section title="Trending"  >
                <DisplayList />
            </Section>
        </>
    );

}

export default Home;
